import { cn } from '@/lib/utils';
import { BreadcrumbItemType } from '@/types/breadcrumb-item.type';
import Image from 'next/image';
import Link from 'next/link';

interface Props {
  items: BreadcrumbItemType[];
}

const Breadcrumb = ({ items }: Props) => {
  // JSON-LD 스키마 데이터 생성
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.label,
      item: item.href
        ? `${process.env.NEXT_PUBLIC_SITE_URL || 'https://www.drivingzone.co.kr'}${item.href}`
        : undefined,
    })),
  };

  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: process.env.NEXT_PUBLIC_SITE_URL || 'https://www.drivingzone.co.kr',
    name: '드라이빙존 운전면허',
    logo: 'https://www.drivingzone.co.kr/logo.png',
  };

  return (
    <nav
      aria-label="breadcrumb"
      className="text-level-4 typo-18 desktop:typo-20 font-medium"
    >
      <ol className="flex items-center">
        {items.map((item, idx) => (
          <li
            key={idx}
            className={cn(
              'flex items-center',
              idx === items.length - 1
                ? 'text-level-2 min-w-0 font-bold'
                : 'shrink-0',
            )}
          >
            {item.href ? (
              <Link
                href={item.href || ''}
                className={cn(idx === items.length - 1 && 'truncate')}
              >
                {item.label}
              </Link>
            ) : (
              <span className={cn(idx === items.length - 1 && 'truncate')}>
                {item.label}
              </span>
            )}
            {/* 마지막이 아니면 구분자 */}
            {idx < items.length - 1 && (
              <span className="desktop:px-1.5 px-1">
                <Image
                  src="/images/icons/icon_breadcrumb_arrow_right.svg"
                  alt=">"
                  width={12}
                  height={12}
                  className="desktop:size-4 size-3"
                />
              </span>
            )}
          </li>
        ))}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        key="breadcrumb-jsonld"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationLd) }}
        key="organization-jsonld"
      />
    </nav>
  );
};

export default Breadcrumb;
